import FormInputSelect from './component.jsx'
export default FormInputSelect
